import { docsApps as rawDocsApps } from './data.js';
import type { SemanticPage } from './types.js';

export const docsApps = rawDocsApps as SemanticPage[];
